import React, { useState } from "react";

const ContactUs = () => {
  const [form, setForm] = useState({
    email: "",
    message: ""
  });

  return (
    <div className="contact-wrapper">

      <div className="contact-container">

        {/* LEFT → REACH TO US */}
        <div className="reach-section">
          <h1>Reach to us</h1>
          <hr />

          <p className="reach-desc">
            Stay connected with MAHARISHI. Send us your message or subscribe
            with your email for updates.
          </p>

          <input
            type="email"
            placeholder="Enter your email"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />

          <textarea
            placeholder="Write your message..."
            rows="4"
            value={form.message}
            onChange={(e) =>
              setForm({ ...form, message: e.target.value })
            }
          ></textarea>

          <button>Submit</button>
        </div>

        {/* RIGHT → CONTACT */}
        <div className="contact-section">
          <h1>Contact</h1>
          <hr />
          <p className="email">maharishi@millets.res.in</p>
          <p className="email">magic2026@millets.res.in</p>
          <p className="email">maharishi.iimr@gmail.com</p>

          {/* EXHIBITOR SERVICES */}
          <h2 className="sub-heading">Contact Address</h2>
          <hr className="sub-hr" />

          <p>MAHARISHI SECRETARIAT</p>
          <p>ICAR-Indian Institute of Millets Research</p>
          <p>Rajendranagar, Hyderabad - 500030 | India</p> 
        </div>

      </div>

      <style>{`

        /* ── Base ── */
        .contact-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 150px;
        }

        .contact-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          width: 100%;
          max-width: 1000px;
        }

        h1 {
          color: #9b2230;
          font-size: 26px;
          margin-bottom: 10px;
          font-weight: 600;
        }

        hr {
          border: none;
          border-top: 2px solid #000;
          margin-bottom: 20px;
        }

        /* SUB HEADING (Exhibitor Services) */
        .sub-heading {
          color: #9b2230;
          font-size: 20px;
          font-weight: 600;
          margin-top: 28px;
          margin-bottom: 8px;
        }

        .sub-hr {
          border: none;
          border-top: 1.5px solid #000;
          margin-bottom: 16px;
        }

        /* LEFT SECTION */
        .reach-section {
          background: #f4f6f8;
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
        }

        .reach-desc {
          font-size: 14px;
          color: #000000;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .reach-section input,
        .reach-section textarea {
          margin-bottom: 15px;
          padding: 12px;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 14px;
          outline: none;
          width: 100%;
          box-sizing: border-box;
        }

        .reach-section input:focus,
        .reach-section textarea:focus {
          border-color: #9b2230;
        }

        .reach-section button {
          background: #9b2230;
          color: white;
          border: none;
          padding: 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          transition: 0.3s;
        }

        .reach-section button:hover {
          background: #7a1a25;
        }

        /* RIGHT SECTION */
        .contact-section {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .contact-section p {
          font-size: 15px;
          color: #444;
          margin-bottom: 12px;
        }

        .email {
          color: #9b2230;
          font-weight: bold;
        }

        /* ── Tablet: 770px ── */
        @media (max-width: 770px) {
          .contact-wrapper {
            padding: 80px 30px;
            align-items: flex-start;
          }

          .contact-container {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .contact-section {
            justify-content: flex-start;
          }
        }

        /* ── Small tablet: 512px ── */
        @media (max-width: 512px) {
          .contact-wrapper {
            padding: 60px 20px;
          }

          h1 {
            font-size: 22px;
          }

          .sub-heading {
            font-size: 18px;
          }

          .reach-section {
            padding: 22px 18px;
          }

          .reach-desc {
            font-size: 13px;
          }

          .reach-section input,
          .reach-section textarea {
            font-size: 13px;
            padding: 10px;
          }

          .contact-section p {
            font-size: 14px;
          }
        }

        /* ── Mobile: 480px ── */
        @media (max-width: 480px) {
          .contact-wrapper {
            padding: 50px 14px 40px;
          }

          .contact-container {
            gap: 24px;
          }

          h1 {
            font-size: 20px;
          }

          .sub-heading {
            font-size: 17px;
            margin-top: 22px;
          }

          .reach-section {
            padding: 18px 14px;
            border-radius: 8px;
          }

          .reach-desc {
            font-size: 12.5px;
            margin-bottom: 14px;
          }

          .reach-section input,
          .reach-section textarea {
            font-size: 12.5px;
            padding: 10px;
            margin-bottom: 12px;
          }

          .reach-section button {
            padding: 10px;
            font-size: 13px;
          }

          .contact-section p {
            font-size: 13px;
            margin-bottom: 10px;
          }
        }

      `}</style>
    </div>
  );
};

export default ContactUs;